import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/targetStock'

const targetStock = axios.create({
  baseURL
})

interceptorsSetup(targetStock)

export default class TargetStock {
  static async get (targetQuery) {
    const result = await targetStock.get('/' + targetQuery.id_site, {})
    return result.data
  }
  static async saveTargets (target) {
    const result = await targetStock.post('/', target)
    return result.data
  }
  static async archiveTarget (target) {
    const result = await targetStock.put('/archive/' + target)
    return result.data
  }
}
